module.exports = __webpack_public_path__ + "61f2a1d53e272b395e5f993590fcddd1.png";